import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import imageSrc from '../../assets/images/slide/start-life-book-woman.png';
import styles from './StartSlideV14.css';

function StartSlideV14({ id, onContinue }) {
    const handleChange = label => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <h1 className={styles.heading}>Could your life fill a book?</h1>
            <p className={styles.subheading}>Pass the quiz to personalize your subscription</p>
            <img src={imageSrc} alt='' className={styles.image} />
            <div className={styles.answers}>
                <button type='button' onClick={handleChange('Yes, definitely!')} className={styles.answerButton}>
                    <span>Yes, definitely!</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
                <button type='button' onClick={handleChange('Maybe even two!')} className={styles.answerButton}>
                    <span>Maybe even two!</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
            </div>
        </div>
    );
}

StartSlideV14.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV14
};
